import { storage } from '@uhg-abyss/web/tools/storage';
import orderBy from 'lodash/orderBy';
import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';

import {
  SET_MEMBER,
  OPEN_RECENT_SEARCH_FLYOUT,
  SET_RECENT_SEARCH,
  LOAD_RECENT_SEARCHES,
  CLEAR_RECENT_SEARCHES,
  TOGGLE_OON_WIDGET,
  SET_SELECTED_PROVIDER_PLN,
  SET_CLAIMS_CRITERIA,
  SET_ELIGIBILITY_CRITERIA,
  SET_REFERRAL_CRITERIA,
  OPEN_TRACKIT_FLYOUT,
  SEARCH_CURRENT_MEMBER,
  DOCLIB_ADV_SEARCH_FLYOUT,
  PROVIDER_PREFERENCE_ERROR,
  SET_VIEWED_PROVIDER_CHAT_MODAL,
  PROVIDER_PREFERENCE_COMPLETE,
} from './constants';

const eligibilityRecentSearches = 'eligibility-recent-searches';

export const setMember = (member) => {
  return createAction({
    type: SET_MEMBER,
    payload: member,
  });
};

export const setSelectedPLNProvider = (data) => {
  return createAction({
    type: SET_SELECTED_PROVIDER_PLN,
    payload: data,
  });
};

export const toggleOONWidget = (isOpen) => {
  return createAction({
    type: TOGGLE_OON_WIDGET,
    payload: isOpen,
  });
};

export const openRecentSearchFlyout = (isOpen) => {
  return createAction({
    type: OPEN_RECENT_SEARCH_FLYOUT,
    payload: isOpen,
  });
};

const formatRecentSearches = (data) => {
  const currentSearches = storage.session.get(eligibilityRecentSearches) || [];
  const newSearches = currentSearches.filter(
    (search) => search.token !== data.token
  );

  newSearches.push(data);
  const orderedSearches = orderBy(
    [...newSearches].reverse(),
    'searchedTime',
    'desc'
  );

  if (orderedSearches.length > 21) {
    orderedSearches.pop();
  }

  storage.session.set(eligibilityRecentSearches, orderedSearches);
  return orderedSearches;
};

export const setRecentSearch = (data) => {
  return createAction({
    type: SET_RECENT_SEARCH,
    payload: formatRecentSearches(data),
  });
};

export const loadRecentSearches = (searches) => {
  return createAction({
    type: LOAD_RECENT_SEARCHES,
    payload: searches,
  });
};

export const clearRecentSearches = (payload) => {
  storage.session.remove(eligibilityRecentSearches);
  return createAction({
    type: CLEAR_RECENT_SEARCHES,
    payload,
  });
};

export const setClaimsCriteria = (data) => {
  return createAction({
    type: SET_CLAIMS_CRITERIA,
    payload: data,
  });
};

export const setEligibilityCriteria = (data) => {
  return createAction({
    type: SET_ELIGIBILITY_CRITERIA,
    payload: data,
  });
};

export const setReferralCriteria = (data) => {
  return createAction({
    type: SET_REFERRAL_CRITERIA,
    payload: data,
  });
};

export const openTrackItFlyout = (isOpen, appName) => {
  return createAction({
    type: OPEN_TRACKIT_FLYOUT,
    payload: {
      isOpen,
      appName,
    },
  });
};

export const searchCurrentMember = (flag) => {
  return createAction({
    type: SEARCH_CURRENT_MEMBER,
    payload: flag,
  });
};

export const handleDocLibSearchFlyout = (isOpen) => {
  return createAction({
    type: DOCLIB_ADV_SEARCH_FLYOUT,
    payload: {
      isOpen,
    },
  });
};

export const updateProviderPreferenceError = (error) => {
  return createAction({
    type: PROVIDER_PREFERENCE_ERROR,
    payload: error,
  });
};

export const setViewedProviderChatModal = (data) => {
  return createAction({
    type: SET_VIEWED_PROVIDER_CHAT_MODAL,
    payload: data,
  });
};

export const setProviderPreferenceComplete = (flag) => {
  return createAction({
    type: PROVIDER_PREFERENCE_COMPLETE,
    payload: flag,
  });
};
